export type NavigationDirection = "forward" | "back";

export function useNavigationDirection() {
  return useState<NavigationDirection>(
    "navigation-direction",
    () => "forward",
  );
}

export function markForwardNavigation() {
  useNavigationDirection().value = "forward";
}

export function markBackNavigation() {
  useNavigationDirection().value = "back";
}
